import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';
import { BulkAssignResponse, BulkAssignServiceRequestsProps } from './types';

type AssignServiceRequestsToUserParams = {
  agentFirmId: string;
  userId: string;
  data: BulkAssignServiceRequestsProps;
};

export async function assignServiceRequestsToUser({
  agentFirmId,
  userId,
  data,
}: AssignServiceRequestsToUserParams) {
  const response = await fetcher(
    `${API_BASE_PATH}/${agentFirmId}/users/${userId}/bulk/assign`,
    {
      method: 'POST',
      body: data,
    }
  );

  if (!response.ok) {
    const responseData = await response.json();
    return {
      success: false,
      error:
        responseData?.message || 'Failed to assign service requests to user',
      statusCode: response.status,
    };
  }

  const responseData: BulkAssignResponse = await response.json();
  return {
    success: true,
    data: responseData,
  };
}
